import { abilitiesPlugin } from '@casl/vue'
import { createApplicationAbility } from './abilityHelper'
import { isGoogleCallbackPath } from '@/access/googleCallback'
import { useAuthStore } from '@/@vxapp/Auth/useAuthStore'

export default async function (app) {
  const authStore = useAuthStore()

  if (typeof window !== 'undefined' && isGoogleCallbackPath(window.location.pathname)) {
    authStore.setStateFromStorage()
    authStore.validateAuthStatus()
    authStore.ability ??= createApplicationAbility([])
  } else {
    await authStore.init('Abilities Plugin')
  }

  authStore.ability ??= createApplicationAbility([])

  const ability = authStore.getAbility('Abilities Plugin')

  app.use(abilitiesPlugin, ability, {
    useGlobalProperties: true,
  })
}
